export const calculateAttachement = (
  attachementsCount: number | undefined,
  hypelinksCount: number | undefined,
) => {
  let att = 0;
  let links = 0;
  if (attachementsCount) att += attachementsCount;
  if (hypelinksCount) links += hypelinksCount;

  return att + links;
};
